var map = {
	"./audio/chess_piece.mp3": "7b67",
	"./audio/seven_days_later.mp3": "697e",
	"./avatars/avatar0.png": "33ea",
	"./avatars/avatar1.png": "0a1c",
	"./avatars/avatar2.png": "096f",
	"./avatars/avatar3.png": "5483",
	"./avatars/avatar4.png": "b009",
	"./lemonz.jpeg": "f5c2",
	"./mahjong.jpeg": "ded4",
	"./mahjong_logo.png": "4698",
	"./pointer.png": "1a1c",
	"./projects": "277c",
	"./projects.js": "277c",
	"./razy_rice.png": "f904",
	"./tiles/Man5-Dora.png": "7a28",
	"./tiles/Pin5-Dora.png": "6838",
	"./tiles/Sou5-Dora.png": "59bc",
	"./tiles/back.png": "e132",
	"./tiles/bai.png": "39b0",
	"./tiles/bei.png": "46b1",
	"./tiles/bing1.png": "d449",
	"./tiles/bing2.png": "52c2",
	"./tiles/bing3.png": "5f2c",
	"./tiles/bing4.png": "e52c",
	"./tiles/bing5.png": "0c64",
	"./tiles/bing6.png": "318c",
	"./tiles/bing7.png": "c44d",
	"./tiles/bing8.png": "b13f",
	"./tiles/bing9.png": "267b",
	"./tiles/dong.png": "8b01",
	"./tiles/fa.png": "04b9",
	"./tiles/front.png": "9eb5",
	"./tiles/nan.png": "8817",
	"./tiles/tiao1.png": "e2f6",
	"./tiles/tiao2.png": "6dbe",
	"./tiles/tiao3.png": "9609",
	"./tiles/tiao4.png": "b466",
	"./tiles/tiao5.png": "fbe2",
	"./tiles/tiao6.png": "6fdc",
	"./tiles/tiao7.png": "2423",
	"./tiles/tiao8.png": "40a2",
	"./tiles/tiao9.png": "fdee",
	"./tiles/wan1.png": "a3f0",
	"./tiles/wan2.png": "e57a",
	"./tiles/wan3.png": "d552",
	"./tiles/wan4.png": "76fa",
	"./tiles/wan5.png": "18b7",
	"./tiles/wan6.png": "9340",
	"./tiles/wan7.png": "ad10",
	"./tiles/wan8.png": "5de4",
	"./tiles/wan9.png": "8b71",
	"./tiles/xi.png": "bb03",
	"./tiles/zhong.png": "2379"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";